/**
 * Calcule les totaux d'achat et de TGC à partir du détail d'un ticket (ticket_detail),
 * ainsi que le nombre de décimales à utiliser selon la ventilation espèce de la société.
 * Utilisé par les pages publiques de consultation (ticket, ticket facture, commande, devis)
 * pour alimenter les composants PDF sans authentification.
 *
 * @param {Array} ticketDetail - Lignes de détail du ticket
 * @param {Object} companyInfos - Infos société (pour advanceparams.ventilation_espece)
 * @returns {{digit:number, totalAchat:number, tgcForTicketPdf:Object, tgcTotal:number}}
 */
export const computePublicTicketTotals = (ticketDetail, companyInfos) => {
    let digit = (companyInfos.advanceparams && companyInfos.advanceparams.hasOwnProperty('ventilation_espece') && companyInfos.advanceparams.ventilation_espece.piece.find(piece=> +piece < 1)) ? 2 : 0;

    let totalAchat = 0
    let totaltgc = {}
    ticketDetail.forEach(item=>{
        totalAchat+=item.prix_remise
        if(item.tgc!=0){
            if(totaltgc[item.tgc]){
                totaltgc={...totaltgc,[item.tgc]:totaltgc[item.tgc]+=item.prix_remise}
            }else{
                totaltgc={...totaltgc,[item.tgc]:item.prix_remise}
            }
        }
    })
    totalAchat=+totalAchat.toFixed(digit)

    let tgcForTicketPdf={}
    Object.entries(totaltgc).forEach(([tgcName,montant])=>{
        let coef = +tgcName / 100 + 1
        let totalAmountTgc = (digit==0) ? +montant - (Math.round(+montant / +coef)) : Math.round((+montant - (Math.round((+montant / +coef)*100)/100))*100)/100
        tgcForTicketPdf[tgcName] = totalAmountTgc
    })
    let tgcTotal = 0
    Object.entries(tgcForTicketPdf).forEach(([key,value])=>
        tgcTotal+=value
    )

    return {digit, totalAchat, tgcForTicketPdf, tgcTotal}
}
